import React from 'react';
import { css } from '@emotion/css';
import { Theme, useTheme } from '@mui/material';
import { GetMobileServiceAppointmentsQuery } from '../../mobileService/queries/getMobileServiceAppointments.query.generated';
import AppointmentCard from './AppointmentCard';

type Appointment = GetMobileServiceAppointmentsQuery['appointments'][number];

interface AppointmentsGridProps {
  appointments: Appointment[];
}

const AppointmentsGrid: React.FC<AppointmentsGridProps> = ({ appointments }) => {
  const theme = useTheme();
  const cls = useStyles(theme);

  return (
    <div className={cls.container}>
      <div className={cls.grid}>
        {appointments.map(appointment => (
          <div key={appointment.id} className={cls.gridItem}>
            <AppointmentCard appointment={appointment} />
          </div>
        ))}
      </div>
    </div>
  );
};

const useStyles = (theme: Theme) => ({
  container: css`
    padding: 24px;
    background-color: ${theme.palette.background.paper};
  `,
  grid: css`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
  `,
  gridItem: css`
    flex: 1 1 380px;
    max-width: 560px;
    min-width: 380px;
  `,
});

export default React.memo(AppointmentsGrid);
